export default __webpack_public_path__ + "static/media/radar_and_moutains.8bcad702.svg";